import React from 'react';
import { useNavigate } from 'react-router-dom';
import { shopConfig as cfg } from '../shopConfig';

// Post-payment landing. Deliberately does NOT read the Stripe session: the webhook is
// the source of truth for whether an order exists. This page only confirms to the
// customer that the payment went through and tells them what happens next.
export const SuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const accent = cfg.brand.accent;

  return (
    <div style={{ padding: '72px 20px 88px', textAlign: 'center', maxWidth: 580, margin: '0 auto' }}>
      <svg width="54" height="54" viewBox="0 0 24 24" fill="none" stroke={accent} strokeWidth="1.6"
        strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: 22 }}>
        <circle cx="12" cy="12" r="10" />
        <path d="M8 12.5l2.5 2.5L16 9.5" />
      </svg>

      <h1 style={{ fontWeight: 900, fontStyle: 'italic', fontSize: 'clamp(26px, 5vw, 38px)', color: cfg.brand.secondary, margin: '0 0 14px' }}>
        Thank you!
      </h1>
      <div style={{ width: 40, height: 3, background: accent, margin: '0 auto 24px' }} />

      <p style={{ fontSize: 15, lineHeight: 1.75, color: 'rgba(0,0,0,.65)', margin: '0 0 10px' }}>
        Your order has been placed and your payment went through. You'll receive a confirmation
        email shortly with the details.
      </p>
      <p style={{ fontSize: 15, lineHeight: 1.75, color: 'rgba(0,0,0,.65)', margin: '0 0 34px' }}>
        Any questions, call us on{' '}
        <a href={`tel:${cfg.contact.phone}`} style={{ color: cfg.brand.secondary, fontWeight: 700 }}>
          {cfg.contact.phone}
        </a>
        .
      </p>

      <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
        <button onClick={() => navigate('/shop')}
          style={{ background: accent, color: cfg.brand.secondary, border: 'none', padding: '14px 30px', fontWeight: 800, fontSize: 11, textTransform: 'uppercase', letterSpacing: '.14em', cursor: 'pointer' }}>
          Continue Shopping
        </button>
        <button onClick={() => navigate('/')}
          style={{ background: 'none', color: 'rgba(0,0,0,.55)', border: '1px solid rgba(0,0,0,.2)', padding: '14px 30px', fontWeight: 800, fontSize: 11, textTransform: 'uppercase', letterSpacing: '.14em', cursor: 'pointer' }}>
          Back to Home
        </button>
      </div>
    </div>
  );
};